'use client';
'use strict';

var jsxRuntime = require('react/jsx-runtime');
var generatedCraftcms = require('@liquorice/generated-craftcms');
var material = require('@mui/material');
var React = require('react');
var reactHookForm = require('react-hook-form');
var createFieldControl = require('../lib/form/createFieldControl.js');
var parseAllowedKinds = require('../lib/parse/parseAllowedKinds.js');
var FieldErrors = require('./FieldErrors/FieldErrors.js');

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const FIELD_FILE_UPLOAD_FRAGMENT = generatedCraftcms.gql(`
  fragment fieldFileUpload on Field_FileUpload {
    __typename
    ...fieldBase
    allowedKinds
    limitFiles
    sizeLimit
    sizeMinLimit
  }
`);
const VisuallyHiddenInput = (props)=>{
    return /*#__PURE__*/ jsxRuntime.jsx("input", _extends({}, props, {
        style: {
            clip: 'rect(0 0 0 0)',
            clipPath: 'inset(50%)',
            height: 1,
            overflow: 'hidden',
            position: 'absolute',
            bottom: 0,
            left: 0,
            whiteSpace: 'nowrap',
            width: 1
        }
    }));
};
const Field_FileUpload = createFieldControl.createField(FIELD_FILE_UPLOAD_FRAGMENT, (field, { methods })=>{
    const { // defaultValue = [],
    handle, label, // placeholder,
    // multi: multiple,
    limitFiles, sizeLimit, // sizeMinLimit,
    required, instructions, labelPosition, allowedKinds } = field;
    const accept = parseAllowedKinds(allowedKinds);
    const maxFiles = parseInt(limitFiles != null ? limitFiles : '1');
    const multiple = maxFiles > 1;
    const maxFileSize = parseInt(sizeLimit != null ? sizeLimit : '10') * 1024 * 1024; // 10MB
    const validateFile = (file)=>{
        if (file.size > maxFileSize) {
            return 'File is too large';
        }
        return null;
    };
    const { field: fieldControl, fieldState } = reactHookForm.useController({
        name: handle,
        defaultValue: [],
        control: methods.control
    });
    const setValue = fieldControl.onChange;
    const [internalValue, setInternalValue] = React.useState(null);
    const [fileErrors, setFileErrors] = React.useState([]);
    const handleCapture = (event)=>{
        const target = event.target;
        const files = target.files ? Array.from(target.files) : [];
        const filesAsText = [];
        const newFileErrors = [];
        files.forEach((file, fileIndex)=>{
            const fileError = validateFile(file);
            const fileName = file.name;
            if (fileError) {
                newFileErrors.push([
                    fileName,
                    fileError
                ]);
                return;
            }
            if (fileIndex >= maxFiles) {
                newFileErrors.push([
                    fileName,
                    'Max files exceeded'
                ]);
                return;
            }
            const reader = new FileReader();
            reader.onload = (e)=>{
                var _e_target;
                const fileData = (_e_target = e.target) == null ? void 0 : _e_target.result;
                if (fileData) {
                    filesAsText[fileIndex] = {
                        fileData: fileData.toString(),
                        filename: file.name
                    };
                    setInternalValue(filesAsText.length ? filesAsText : null);
                    setValue(filesAsText.length ? filesAsText : null);
                }
            };
            reader.readAsDataURL(file);
        });
        setFileErrors(newFileErrors);
    };
    const handleRemove = (fileIndex)=>()=>{
            const currentValue = internalValue != null ? internalValue : [];
            const newValue = currentValue.filter((_, i)=>i !== fileIndex);
            setInternalValue(newValue.length ? newValue : null);
            setValue(newValue.length ? newValue : null);
        };
    var _internalValue_length;
    // const maxFiles = limitFiles ? Number(limitFiles) || 1 : undefined;
    const nFiles = (_internalValue_length = internalValue == null ? void 0 : internalValue.length) != null ? _internalValue_length : 0;
    const allowAdd = nFiles < maxFiles;
    return /*#__PURE__*/ jsxRuntime.jsxs(material.FormControl, {
        required: required,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx(material.FormLabel, {
                component: "legend",
                sx: {
                    mb: 2
                },
                hidden: labelPosition === 'hidden',
                children: label
            }),
            /*#__PURE__*/ jsxRuntime.jsx(material.FormHelperText, {
                children: instructions
            }),
            /*#__PURE__*/ jsxRuntime.jsxs(material.Button, {
                component: "label",
                role: undefined,
                variant: "outlined",
                tabIndex: -1,
                disabled: !allowAdd,
                children: [
                    "Choose File(s)",
                    /*#__PURE__*/ jsxRuntime.jsx(VisuallyHiddenInput, {
                        type: "file",
                        onChange: handleCapture,
                        multiple,
                        accept,
                        style: {
                            display: 'none'
                        }
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsx(material.Stack, {
                /* rowGap={2} */ alignItems: "flex-start",
                sx: {
                    mt: 2
                },
                children: internalValue == null ? void 0 : internalValue.map((file, i)=>/*#__PURE__*/ jsxRuntime.jsx(material.Button, {
                        variant: "text",
                        // endIcon={<CloseIcon />}
                        sx: {
                            textTransform: 'none'
                        },
                        onClick: handleRemove(i),
                        children: file.filename
                    }, i))
            }),
            fileErrors.map(([name, error], i)=>/*#__PURE__*/ jsxRuntime.jsxs(material.FormHelperText, {
                    error: true,
                    children: [
                        name,
                        ": ",
                        error
                    ]
                }, i)),
            /*#__PURE__*/ jsxRuntime.jsx(FieldErrors, {
                errors: fieldState.error
            })
        ]
    });
});

exports.FIELD_FILE_UPLOAD_FRAGMENT = FIELD_FILE_UPLOAD_FRAGMENT;
exports.Field_FileUpload = Field_FileUpload;
